import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./servicespare.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const products = {
  combineHarvester: [
    { id: "1", productName: "Dasmesh 9100", subCate: "Combineharvester" },
    { id: "2", productName: "Dasmesh 9100 Maize", subCate: "Combineharvester" },
    { id: "3", productName: "Dasmesh 7100", subCate: "Combineharvester" },
    { id: "4", productName: "Dasmesh 3100", subCate: "Combineharvester" },
    { id: "5", productName: "Dasmesh 912 2WD", subCate: "Combineharvester" },
    { id: "6", productName: "Dasmesh 912 4WD", subCate: "Combineharvester" },
    { id: "7", productName: "Dasmesh 731 Track", subCate: "Combineharvester" },
    { id: "8", productName: "Dasmesh 726 Track", subCate: "Combineharvester" },
    {
      id: "9",
      productName: "Dasmesh Maize Header",
      subCate: "Combineharvester",
    },
     {
      id: "20",
      productName: "Dasmesh 831",
      subCate: "Combineharvester",
    },
    // Additional combine harvester products
  ],
  agriImplements: [
    { id: "10", productName: "Dasmesh Rotavator", subCate: "agriImplements" },
    {
      id: "11",
      productName: "Dasmesh Laser Land Leveller",
      subCate: "agriImplements",
    },
    {
      id: "12",
      productName: "Dasmesh Super Seeder",
      subCate: "agriImplements",
    },
    {
      id: "13",
      productName: "Dasmesh Straw Reaper",
      subCate: "agriImplements",
    },
    {
      id: "14",
      productName: "Dasmesh Square Baler",
      subCate: "agriImplements",
    },
    { id: "15", productName: "Dasmesh Round Baler", subCate: "agriImplements" },
    { id: "16", productName: "Dasmesh Hey Rake", subCate: "agriImplements" },
    {
      id: "17",
      productName: "Dasmesh Zero Till Drill",
      subCate: "agriImplements",
    },
    { id: "18", productName: "Dasmesh DSR Drill", subCate: "agriImplements" },
    {
      id: "19",
      productName: "Dasmesh Paddy Straw Chopper",
      subCate: "agriImplements",
    },
    // Additional agri implements products
  ],
};

const Spareandservice = () => {
  const currentYear = new Date().getFullYear(); // Get the current year
  const years = Array.from({ length: 55 }, (_, i) => currentYear - i); // Generate a list of the last 10 years

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    country: "",
    postalCode: "",
    equipment: "",
    model: "",
    purchased: "",
    invoice: "",
    invoiceDate: "",
    description: "",
    consent: false,
  });

  const [loading, setLoading] = useState(false); // Loader state

  // const handleInputChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));
  // };

  const handleDateChange = (date) => {
    setFormData((prevData) => ({
      ...prevData,
      invoiceDate: date,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
  
    // Allow only numeric values for "phone" field
    if (name === "phone") {
      const numericValue = value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
      setFormData({
        ...formData,
        [name]: numericValue,
      });
    } else {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value,
      });
    }
  };

  //   const handleSubmit = (e) => {
  //     e.preventDefault();
  //     // Perform form submission logic here
  //     console.log('Form Submitted:', formData);

  //     // You can send the form data to an API
  //     // Example: axios.post('/api/submit', formData).then(...).catch(...)
  //   };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Show loader on form submit

    try {
      const response = await fetch("https://dasmesh-mailer.ritaz.in/spare-send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        // alert("Email sent successfully!");
        toast.success("Email sent successfully!"); // Success toast
        setFormData({}); // Reset form data
        resetForm(); // Call reset function after success
      } else {
        // alert("Error sending email!");
        toast.error("Error sending email!"); // Error toast
      }
    } catch (error) {
      //   alert("Error sending email!");
      toast.error("Error sending email!"); // Error toast
    } finally {
      setLoading(false); // Hide loader after submission
    }
  };

  const defaultFormData = {
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    country: "",
    postalCode: "",
    equipment: "",
    model: "",
    purchased: "",
    invoice: "",
    invoiceDate: "",
    description: "",
    consent: false,
  };

  // Reset form function
  const resetForm = () => {
    setFormData(defaultFormData); // Reset all fields to their initial state
  };

  return (
    <>
      <div className="contact-form-contact">
        <div className="servide-hdr">
          <h1>SPARES & SERVICE REQUEST</h1>
          <p>
            Fill in the form below or send your requirement directly on{" "}
            <a href="mailto:spd@dasmesh.com">spd@dasmesh.com</a> and we will
            provide you the best quote as soon as possible
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="phone"
                placeholder="Phone No."
                value={formData.phone}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="address"
                placeholder="Local Address"
                value={formData.address}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="city"
                placeholder="City"
                value={formData.city}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="state"
                placeholder="State/Province"
                value={formData.state}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="country"
                placeholder="Country"
                value={formData.country}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="postalCode"
                placeholder="Postal Code"
                value={formData.postalCode}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>

          <div className="form-group full-width">
            <select
              name="equipment"
              value={formData.equipment}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Equipment Type</option>
              <optgroup label="COMBINE HARVESTER">
                {products.combineHarvester.map((item) => (
                  <option key={item.id} value={item.productName}>
                    {item.productName}
                  </option>
                ))}
              </optgroup>
              <optgroup label="AGRI. IMPLEMENTS">
                {products.agriImplements.map((item) => (
                  <option key={item.id} value={item.productName}>
                    {item.productName}
                  </option>
                ))}
              </optgroup>
            </select>
          </div>

          <div className="form-group full-width">
            <select
              name="model"
              value={formData.model}
              onChange={handleInputChange}
              required
            >
              <option value="" disabled>
                Select Year of Purchase
              </option>
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group full-width">
            <input
              type="text"
              name="purchased"
              placeholder="Purchased From"
              value={formData.purchased}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <input
              type="text"
              name="invoice"
              placeholder="Invoice Number"
              value={formData.invoice}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <DatePicker
              selected={formData.invoiceDate}
              onChange={handleDateChange}
              placeholderText="Invoice Date"
              dateFormat="yyyy-MM-dd"
              className="form-control"
              required
            />
          </div>

          <div className="form-group full-width">
            <textarea
              name="description"
              placeholder="Describe Issue/Complaints"
              value={formData.description}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="contact-checkbox-form">
            <input
              type="checkbox"
              name="consent"
              checked={formData.consent}
              onChange={handleInputChange}
              required
            />
            <p>
              By checking this box, you consent and agree to DASMESH sending
              text messages or placing voice calls (live or pre-recorded), to
              the telephone number you have provided, for advertising and
              telemarketing purposes. You understand that you are not required
              to sign or enter into this agreement as a condition of purchasing
              any property, goods, or services. You further accept our privacy
              policy and Legal Disclaimer. *
            </p>
          </div>

          {/* <span> <input type="submit" name="submit" value="Send" /> </span> */}
          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Send Email"}
          </button>
        </form>
        {/* Toast container */}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
          draggable
        />
      </div>
    </>
  );
};

export default Spareandservice;
